import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";
import axios from "axios";




const OrderSummaryPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { posto, pin, order = {} } = location.state || {};
  const [localOrder, setLocalOrder] = useState(order);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  
const isProcessingRef = useRef(false); // add at top of component


const isHappyHour = () => {
  const now = new Date();
  const hour = now.getHours();
  return hour >= 17 && hour < 18;
};

const isHappyHourItem = (itemName) => {
  const happyHourItems = ["Aperol Spritz", "Campari Spritz"];
  return happyHourItems.includes(itemName) && isHappyHour();
};


  const handleQuantityChange = (key, delta) => {
    setLocalOrder((prev) => {
      const newQty = (prev[key]?.qty || 0) + delta;
      if (newQty <= 0) {
        const { [key]: _, ...rest } = prev;
        return rest;
      }
      return {
        ...prev,
        [key]: {
          ...prev[key],
          qty: newQty,
        },
      };
    });
  };

  const orderEntries = Object.entries(localOrder);
const baseTotal = orderEntries.reduce(
  (sum, [_, item]) =>
    sum +
    (isHappyHourItem(item.nome) ? 5 : item.prezzo) * item.qty,
  0
);

const totalPrice = orderEntries.length > 0 ? baseTotal + 1 : 0;



  const handleBackToMenu = () => {
    navigate("/menu", {
      state: {
        posto,
        pin,
        order: localOrder,
      },
    });
  };

const handleStripePayment = async () => {
  if (isProcessingRef.current) return;
  isProcessingRef.current = true;

  setLoading(true);

  if (!email || !email.includes("@")) {
    alert("Per favore inserisci una email valida.");
    setLoading(false);
    isProcessingRef.current = false;
    return;
  }

  if (!phone || phone.length < 6) {
    alert("Inserisci un numero di telefono valido.");
    setLoading(false);
    isProcessingRef.current = false;
    return;
  }

  if (!consent) {
    alert("Devi autorizzare il trattamento dei dati personali.");
    setLoading(false);
    isProcessingRef.current = false;
    return;
  }

  const baseTotal = Object.values(localOrder).reduce(
    (sum, item) =>
      sum + (isHappyHourItem(item.nome) ? 5 : item.prezzo) * item.qty,
    0
  );
  const total = Object.keys(localOrder).length > 0 ? baseTotal + 1 : 0;

  const orderToSend = Object.entries(localOrder).reduce((acc, [key, item]) => {
    acc[key] = {
      nome: item.nome,
      prezzo: isHappyHourItem(item.nome) ? 5 : item.prezzo,
      qty: item.qty,
    };
    return acc;
  }, {});

  try {
    const res = await axios.post("https://api.lidodavittorio.it/api/create-checkout-session", {
      order: orderToSend,
      posto,
      email,
      phone,
    });

    const orderId = res.data.orderId;

    localStorage.setItem(
      "latestOrder",
      JSON.stringify({
        orderId,
        posto,
        order: orderToSend,
        email,
        phone,
        prezzo: total,
      })
    );

    window.location.href = res.data.url;
  } catch (err) {
    alert("Errore nel pagamento");
    console.error(err);
    setLoading(false);
    isProcessingRef.current = false;
  }
};



  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <NavbarWhite />

      <div className="pt-32 px-4 sm:px-6 text-center flex-1 max-w-4xl mx-auto">
        {/* 🔙 Back Button */}
        {posto && (
          <div className="flex justify-end mb-4">
            <button
              onClick={handleBackToMenu}
              className="text-sm sm:text-base bg-gray-100 text-[#009FB7] font-[chivo] px-4 py-2 rounded-md hover:bg-gray-200 transition"
            >
              ↩ Torna al Menù
            </button>
          </div>
        )}

        <h1 className="text-4xl sm:text-5xl font-[chivo] text-[#009FB7] mb-8">
          Riepilogo Ordine
        </h1>

        {posto ? (
          <>
            <div className="text-lg font-[chivo] mb-10">
              <p>
                <strong>N° Posto:</strong> {posto}
              </p>
              {pin && (
                <p>
                  <strong>PIN:</strong> {pin}
                </p>
              )}
            </div>

            {orderEntries.length === 0 ? (
              <p className="text-gray-600 font-[chivo]">
                Nessun prodotto selezionato.
              </p>
            ) : (
              <>
                <div className="max-h-80 overflow-y-auto pr-2 space-y-6 text-left  mb-4">
                  {orderEntries.map(([key, item]) => (
                    <div
                      key={key}
                      className="border-b pb-4 flex justify-between items-center"
                    >
                      <div>
                        <p className="font-[chivo] text-lg">{item.nome}</p>
<p className="text-sm text-gray-500">
  Quantità: {item.qty} × €{isHappyHourItem(item.nome) ? "5.00" : item.prezzo.toFixed(2)} ={" "}
  <strong className="text-[#009FB7]">
    €{(item.qty * (isHappyHourItem(item.nome) ? 5 : item.prezzo)).toFixed(2)}
  </strong>
</p>

                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleQuantityChange(key, -1)}
                          className="bg-gray-300 text-black px-3 py-1 rounded hover:bg-gray-400"
                        >
                          -
                        </button>
                        <span className="font-[chivo]">{item.qty}</span>
                        <button
                          onClick={() => handleQuantityChange(key, 1)}
                          className="bg-[#009FB7] text-white px-3 py-1 rounded hover:bg-[#007d99]"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
<p className="text-right font-[chivo]">
  Spesa: €{baseTotal.toFixed(2)}
</p>
<p className="text-right font-[chivo] text-sm text-gray-600">
  + €1 consegna
</p>
<p className="text-right font-bold text-lg text-[#009FB7] font-[chivo]">
  Totale: €{totalPrice.toFixed(2)}
</p>

                <div className="mt-6 text-center mb-2 space-y-2">
  <input
    type="email"
    placeholder="Inserisci la tua email"
    className="border border-gray-300 rounded px-4 py-2 w-full max-w-md font-[chivo]"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
  />
  <input
    type="tel"
    placeholder="Inserisci il tuo numero di telefono"
    className="border border-gray-300 rounded px-4 py-2 w-full max-w-md font-[chivo]"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
    required
  />
  <div className="text-sm text-left max-w-md mx-auto flex items-start gap-2">
    <input
      type="checkbox"
      checked={consent}
      onChange={(e) => setConsent(e.target.checked)}
    />
    <label>
      Autorizzo il trattamento dei miei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).
    </label>
  </div>
</div>

<div className="mt-2 text-center mb-8">
<button
  type="button"  // ✅ Important: prevents unintended form submission
  onClick={handleStripePayment}
  disabled={loading}
  className={`${
    loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#009FB7] hover:bg-[#007d99]"
  } text-white text-lg px-8 py-3 rounded-md transition font-[chivo] mt-2`}
>
  {loading ? "Generazione ordine..." : (
    <>
      Paga Ora –{" "}
      <span className="font-bold text-yellow-300">
        €{totalPrice.toFixed(2)}
      </span>
    </>
  )}
</button>


</div>
              </>
            )}
          </>
        ) : (
          <p className="text-red-600 font-[chivo] text-lg">⚠️ Accesso negato</p>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default OrderSummaryPage;
